import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
				  })
			})
	},
    
    recuperar(p_email, p_usuario, p_ejecutivo, p_fedesde, p_fehasta) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_ejecutivo": p_ejecutivo,
					"p_fedesde": p_fedesde,
					"p_fehasta": p_fehasta
				  })
			})
	},

	recuperar_liquid(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.recuperar_liquid",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro
				  })
			})
	},

	recuperar_devolucion(p_email, p_usuario, p_siniestro, p_tratamiento, p_mtorecmoneda, p_mtorecpesos, p_gastosmoneda, p_gastospesos) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.recuperar_devolucion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro,
					"p_tratamiento": p_tratamiento,
					"p_mtorecmoneda": p_mtorecmoneda,
                    "p_mtorecpesos": p_mtorecpesos, 
                    "p_gastosmoneda": p_gastosmoneda, 
                    "p_gastospesos": p_gastospesos
				  })
			})
	},

	recuperar_beneficiario(p_email, p_usuario, p_siniestro) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.recuperar_beneficiario",
				"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_siniestro": p_siniestro
				})
			})
	},

	reg_marca_devolucion(p_email, p_usuario, p_sntsiniestro, p_sntdevolucion, p_sntfolio, p_sntestado, p_sntttorecup, p_subestado, p_obssubestado, p_opciongast){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_devoluciones.reg_marca_devolucion",
			"p_args_in": JSON.stringify({
			"p_usuario": p_usuario,
			"p_sntsiniestro": p_sntsiniestro,
			"p_sntdevolucion": p_sntdevolucion,
			"p_sntfolio": p_sntfolio,
			"p_sntestado": p_sntestado,
			"p_sntttorecup": p_sntttorecup,
			"p_subestado": p_subestado,
			"p_obssubestado": p_obssubestado,
			"p_opciongast": p_opciongast
			})
		})
	},

	reg_devolucion(p_email, p_usuario, p_siniestro, 
				   p_devolucion, p_moneda, p_monto){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_devoluciones.reg_devolucion",
			"p_args_in": JSON.stringify({
			"p_usuario": p_usuario,
			"p_siniestro": p_siniestro,
			"p_devolucion": p_devolucion,
			"p_moneda": p_moneda,
			"p_monto": p_monto
			})
		})
	},
	
	insert_update_beneficiario(p_email, p_usuario, p_sbcsiniestro, p_sbccodbenef, 
					   		   p_sbcmoneda, p_sbcmonto, p_sbcporcentaje) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.insert_update_beneficiario",
				"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_sbcsiniestro": p_sbcsiniestro, 
				"p_sbccodbenef": p_sbccodbenef, 
				"p_sbcmoneda": p_sbcmoneda, 
				"p_sbcmonto": p_sbcmonto, 
				"p_sbcporcentaje": p_sbcporcentaje
				})
			})
	},

	delete_beneficiario(p_email, p_usuario, p_sbcsiniestro, p_sbccodbenef) {
		return axios
			.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_devoluciones.delete_beneficiario",
			"p_args_in": JSON.stringify({
			"p_usuario": p_usuario,
			"p_sbcsiniestro": p_sbcsiniestro, 
			"p_sbccodbenef": p_sbccodbenef, 
			})
		})
	},

	buscar_beneficiario(p_email, p_usuario, p_sbccodbenef) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.buscar_beneficiario",
				"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_sbccodbenef": p_sbccodbenef
				})
			})
	},

	obt_nrodevolucion(p_email, p_usuario) {
		return axios
		.post('spoc/modppentry', {
		"p_email": p_email,
		"p_metodo": "pkg_sinpp_devoluciones.obt_nrodevolucion",
		"p_args_in": JSON.stringify({
			"p_usuario": p_usuario
				})
		})
	},

    pre_insercion_vb(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.pre_insercion_vb",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario
				  })
			})
	},

	pre_insercion_devolucion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.pre_insercion_devolucion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario
				  })
			})
	},

	recuperar_vbgerente(p_email, p_usuario, p_fecpago) {
        return axios
        .post('spoc/modppentry', {
        "p_email": p_email,
        "p_metodo": "pkg_sinpp_devoluciones.recuperar_vbgerente",
        "p_args_in": JSON.stringify({
        "p_usuario": p_usuario,
		"p_fecpago": p_fecpago
                })
        })
    },

	recuperar_resumen(p_email, p_usuario, p_siniestro, p_slqdevolucion) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.recuperar_resumen",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_siniestro": p_siniestro,
					"p_slqdevolucion": p_slqdevolucion
				  })
			})
	},

	nombre_asegurado(p_email, p_usuario, p_asegurado) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_indemniza.nombre_asegurado",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_asegurado": p_asegurado
				  })
			})
	},

	nombre_beneficiario(p_email, p_usuario, p_beneficiario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_indemniza.nombre_beneficiario",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_beneficiario": p_beneficiario
				  })
			})
	},

	autorizar(p_email, p_usuario, p_slqdevolucion) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.marcarvb",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_slqdevolucion": p_slqdevolucion
				  })
			})
	},

	rechazar(p_email, p_usuario, p_slqdevolucion, p_observacion) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.rechazarvb",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_slqdevolucion": p_slqdevolucion,
					"p_observacion": p_observacion
				})
		})
	},
	
	devolucion(p_email, p_usuario, p_fecpago, p_codasegurado, p_codbeneficiario) {
        return axios
       .post('spoc/modppentry', {
        "p_email": p_email,
        "p_metodo": "pkg_sinpp_devoluciones.devolucion",
        "p_args_in": JSON.stringify({
            "p_usuario": p_usuario,
			"p_fecpago": p_fecpago,
			"p_codasegurado": p_codasegurado,
			"p_codbeneficiario": p_codbeneficiario
                })
        })
    },

    devolver(p_email, p_usuario, p_folios, p_fecpago) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.devolver",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_folios": p_folios,
					"p_fecpago": p_fecpago
				  })
			})
	},

	mail_devolver(p_email, p_usuario, p_nrodevolucion) {
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_devoluciones.mail_devolver",
				"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_nrodevolucion": p_nrodevolucion
				})
			})
	},

	modificarfecha(p_email, p_usuario, p_fecha, p_slqdevolucion) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.modificarfecha",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_fecha": p_fecha,
					"p_slqdevolucion": p_slqdevolucion
				  })
			})
	},
	
	
	nodevolver(p_email, p_usuario, p_nrodevolucion, p_motivo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.nodevolver",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_nrodevolucion": p_nrodevolucion,
					"p_motivo": p_motivo
				  })
			})
	},

	recalcular(p_email, p_usuario, p_nrodevolucion) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.recalcular",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_nrodevolucion": p_nrodevolucion
				  })
			})
	},

	fnc_insertdatos(p_email, p_aviso, p_siniestro, p_dato, p_valor, p_usuario, p_valnro, p_valfec) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.fnc_insertdatos",
				"p_args_in": JSON.stringify({
					"p_aviso": p_aviso,   
					"p_siniestro": p_siniestro, 
					"p_dato": p_dato, 
					"p_valor": p_valor, 
					"p_usuario": p_usuario,
					"p_valnro": p_valnro, 
					"p_valfec": p_valfec
				  })
			})
	},

	fnc_buscardatos(p_email, p_usuario, p_aviso, p_siniestro, p_dato) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_devoluciones.fnc_buscardatos",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_aviso": p_aviso,   
					"p_siniestro": p_siniestro, 
					"p_dato": p_dato
				  })
			})
	},
}